import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../../incidentes.css";
import temas from "./pythonTemas";

const Python = () => {
  const bucketUrl = process.env.REACT_APP_BUCKET;
  return (
    <>
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Curso de Python</h1>
        </div>
        <div className="orgproc-grid-4col">
          {temas.map((tema, index) => (
            <div className="orgproc-card" key={tema.titulo}>
              <div className="orgproc-card-accent"></div>
              <div className="orgproc-card-body">
                <div className="orgproc-eyebrow">Tema #{index + 1}</div>
                <div className="orgproc-card-title">{tema.titulo}</div>
                <div className="orgproc-card-actions">
                  <Link className="orgproc-card-btn" to={tema.to}>
                    Ver PDF →
                  </Link>
                  <a
                    className="orgproc-card-btn"
                    href={`${bucketUrl}/${tema.material}`}
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Descargar Material →
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </>
  );
};

export default Python;